// 专业课学长学姐
export default [

  {
    path: '/majorSenior',
    component: () => import('@/pages/majorSenior/index.vue'),
    meta: {
      title: '学长学姐',
    },
  },
  {
    path: '/personDetail',
    component: () => import('@/pages/majorSenior/personDetail.vue'),
    meta: {
      title: '个人信息',
      requireAuth: true,
    },
  },
  {
    path: '/oneToOnePersonDetail',
    component: () => import('@/pages/majorSenior/personDetail.vue'),
    meta: {
      title: '个人信息',
      requireAuth: true,
    },
  },
  {
    path: '/university',
    component: () => import('@/pages/majorSenior/university.vue'),
    meta: {
      title: '院校列表',
      requireAuth: false,
    },
  },

];
